import React from "react";
import {
  Box,
  CssBaseline,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Divider,
} from "@mui/material";

import { AccountTree, Person, Receipt, Timeline } from "@mui/icons-material";
import MyAppBar from "./MyAppBar";
import { Outlet, useLocation, Link } from "react-router-dom";
import logo from "../Assets/logo small.png";
import SpaceDashboardIcon from '@mui/icons-material/SpaceDashboard';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import PaymentsIcon from '@mui/icons-material/Payments';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import BadgeIcon from '@mui/icons-material/Badge';

const drawerWidth = 250;
const collapsedWidth = 100;
const activeColor = "rgba(255, 255, 255, 0.16)";

const ResponsiveDrawer: React.FC = () => {
  const [drawerOpen, setDrawerOpen] = React.useState(true);
  const location = useLocation();

  const handleDrawerCollapse = () => {
    setDrawerOpen((prev) => !prev);
  };

  const menuItems = [
    {
      text: "Master",
      icon: <Person />,
      path: "/MasterScreen",
      matchPaths: [
        "/MasterScreen",
        "/EmployeeTable",
        "/AddEmployee",
        "/ViewEmployee",
        "/DeleteEmployee",
      ],
    },
    { text: "TimeSheet", icon: <Timeline />, path: "/TimeSheet" },
    { text: "Invoice", icon: <InsertDriveFileIcon />, path: "/InvoiceTable" },
    { text: "Dashboard", icon: <SpaceDashboardIcon />, path: "/Dashboard" },
    { text: "External Incentive", icon: <PaymentsIcon />, path: "/Incentivepage" },
    { text: "Configuration", icon: <CurrencyExchangeIcon />, path: "/configurationscreen" },
    { text: "Emp mapping", icon: <BadgeIcon />, path: "/EmpMapping" },
    
  ];

  return (
    <Box sx={{ display: "flex", overflowX: "hidden" }}>
      <CssBaseline />

      <Drawer
        variant="permanent"
        sx={{
          zIndex: 9999,
          width: drawerOpen ? drawerWidth : collapsedWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerOpen ? drawerWidth : collapsedWidth,
            transition: "width 0.3s ease-in-out",
            overflowX: "hidden",
            boxSizing: "border-box",
            border: "0px",
            backgroundColor: "#1D2129",
            boxShadow: 0,
            paddingTop: 0,
            paddingX: 2,
          },
        }}
      >
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: drawerOpen ? "space-between" : "flex-start",
            alignItems: "center",
            px: 2,
          }}
        >
          {drawerOpen ? (
            <img
              src="https://cognitivevaluetech.com/Content/img/log_h40.png"
              alt="Full Logo"
              style={{ width: "150px", height: "auto" }}
            />
          ) : (
            <img
              src={logo}
              alt="Collapsed Logo"
              style={{ width: "35px", height: "auto" }}
            />
          )}
        </Toolbar>
        <Divider />
        <List>
          {menuItems.map((item) => {
            const isActive = item.matchPaths
              ? item.matchPaths.some((p) => location.pathname.startsWith(p))
              : location.pathname.startsWith(item.path);

            return (
              <ListItem
                key={item.text}
                disablePadding
                sx={{ display: "block", marginBottom: 1 }}
              >
                <ListItemButton
                  component={Link}
                  to={item.path}
                  sx={{
                    borderRadius: "10px",
                    padding: "5px",
                    marginBottom: "5px",
                    justifyContent: drawerOpen ? "initial" : "center",
                    bgcolor: isActive ? activeColor : "inherit",
                    color: isActive ? "#31A8F4" : "#717481",
                    "&:hover": {
                      bgcolor: activeColor,
                    },
                  }}
                >
                  <ListItemIcon
                    sx={{
                      color: isActive ? "#31A8F4" : "#717481",
                      minWidth: 0,
                      mr: drawerOpen ? 2 : 0,
                      justifyContent: "center",
                    }}
                  >
                    {React.cloneElement(item.icon, {
                      sx: { fontSize: drawerOpen ? 25 : 35 },
                    })}
                  </ListItemIcon>
                  {drawerOpen && <ListItemText primary={item.text} />}
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>
      </Drawer>

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minHeight: "100vh",
          padding: "0px",
          backgroundColor: "rgb(238, 242, 246)",
        }}
      >
        <MyAppBar
          handleDrawerCollapse={handleDrawerCollapse}
          drawerOpen={drawerOpen}
        />
        <Toolbar />
        <Outlet />
      </Box>
    </Box>
  );
};

export default ResponsiveDrawer;
